import { cartPlugin } from '@gmao/shared';
import { socketIo } from '@gmao/sync';
import { authPlugin } from '@shared/logto/vue';
import { asyncHandler, debugPlugin, descreteApi, onlineChecker } from '@shared/naive-ui';
import { createApp } from 'vue';
import App from './App.vue';

import { client } from './client';
import { authConfig } from './config/auth';
import { missionContext } from './infra';
import { router } from './router';
import { setupSentry } from './sentry';
import 'uno.css';
import '@unocss/reset/normalize.css';
import 'vfonts/Lato.css';
import 'vfonts/FiraCode.css';
import '@gmao/shared/styles.css';
import './styles.css';

export const app = createApp(App);

setupSentry(app);

// Setup
app
  .use(router)
  .use(debugPlugin)
  .use(asyncHandler)
  .use(onlineChecker, { socketIo })
  .use(authPlugin, { config: authConfig, client })
  .use(missionContext, { router })
  .use(cartPlugin);

// Without it the browser may evict the events not sent yet when the device runs low on space
void navigator.storage?.persist?.().then((granted) => {
  if (granted || localStorage.getItem('storage.persist.warned'))
    return;
  localStorage.setItem('storage.persist.warned', '1');
  descreteApi.notification.warning({
    title: 'Storage not protected',
    content: 'This device may delete the data of the app when it runs low on space. Send your events regularly.',
    duration: 10000,
  });
});

app.mount('#app');
